export enum IssueSelectorErrorType {
    MissingValue = 'MissingValue',
    DuplicateValue = 'DuplicateValue',
    InvalidValue = 'InvalidValue',
    DuplicateVariations = 'DuplicateVariations',
    DuplicateValueInVariations = 'DuplicateValueInVariations',
    DuplicateVariationInValues = 'DuplicateVariationInValues',
    SpecialCharactersNotAllowed = 'SpecialCharactersNotAllowed'
}

export interface IssueSelectorError {
    type: IssueSelectorErrorType;
    data: any[];
    key?: string
}

export interface MissingValueIssueSelectorError extends IssueSelectorError {
    type: IssueSelectorErrorType.MissingValue;
    key: string;
}

export interface DuplicateValueIssueSelectorError extends IssueSelectorError {
    type: IssueSelectorErrorType.DuplicateValue;
    key: string;
}


export interface InvalidValueIssueSelectorError extends IssueSelectorError {
    type: IssueSelectorErrorType.InvalidValue;
    key: string;
}

export interface DuplicateVariationsIssueSelectorError extends IssueSelectorError {
    type: IssueSelectorErrorType.DuplicateVariations;
    key: string;
}

export interface DuplicateVariationsInValuesIssueSelectorError extends IssueSelectorError {
    type: IssueSelectorErrorType.DuplicateVariationInValues;
    key: string;
}

export interface DuplicateValueInVariationsIssueSelectorError extends IssueSelectorError {
    type: IssueSelectorErrorType.DuplicateValueInVariations;
    key: string;
}

export interface SpecialCharactersInVariationsIssueSelectorError extends IssueSelectorError {
    type: IssueSelectorErrorType.SpecialCharactersNotAllowed;
    key: string;
}